// Auto-generated file - do not edit manually
// Run: node scripts/generateTilesCache.js

export type TilePathData = {
  pathData: {
    rock: number[][];
    sand: number[][];
    water: number[][];
    dock: number[][];
  };
};

export const tilesPathsCache: Record<number, TilePathData> = {
  "1": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          1,
          12,
          2,
          12,
          4,
          14,
          6,
          14,
          10,
          13,
          11,
          13,
          13,
          11,
          15,
          11,
          16,
          3,
          16,
          3,
          13,
          4,
          12,
          4,
          11,
          5,
          10,
          5,
          8,
          6,
          7,
          6,
          4,
          3,
          1,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          13,
          4,
          12,
          4,
          11,
          5,
          10,
          5,
          8,
          6,
          7,
          6,
          4,
          3,
          1,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "2": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          1,
          10,
          2,
          10,
          4,
          11,
          5,
          11,
          6,
          9,
          8,
          9,
          11,
          10,
          12,
          10,
          14,
          11,
          15,
          11,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          10,
          3,
          9,
          3,
          8,
          5,
          6,
          5,
          4,
          4,
          3,
          4,
          2,
          3,
          1,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          10,
          3,
          9,
          3,
          8,
          5,
          6,
          5,
          4,
          4,
          3,
          4,
          2,
          3,
          1,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "3": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          1,
          12,
          2,
          12,
          5,
          11,
          6,
          11,
          10,
          12,
          11,
          12,
          13,
          11,
          14,
          11,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          9,
          3,
          8,
          3,
          6,
          4,
          5,
          4,
          3,
          3,
          2,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          9,
          3,
          8,
          3,
          6,
          4,
          5,
          4,
          3,
          3,
          2,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "4": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          2,
          10,
          3,
          5,
          3,
          3,
          1,
          3,
          0,
          11,
          0
        ],
        [
          9,
          12,
          11,
          14,
          11,
          16,
          3,
          16,
          3,
          12,
          6,
          9,
          8,
          9,
          9,
          8
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          12,
          6,
          9,
          8,
          9,
          11,
          6,
          13,
          6,
          14,
          5,
          14,
          4,
          13,
          3,
          5,
          3,
          3,
          1,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "5": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          1,
          12,
          2,
          12,
          4,
          5,
          4,
          3,
          2,
          3,
          0,
          11,
          0
        ],
        [
          10,
          10,
          10,
          13,
          11,
          14,
          11,
          16,
          3,
          16,
          3,
          14,
          5,
          12,
          5,
          10,
          7,
          8,
          9,
          8,
          10,
          9,
          11,
          9
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          14,
          5,
          12,
          5,
          10,
          7,
          8,
          9,
          8,
          10,
          9,
          11,
          9,
          12,
          10,
          14,
          10,
          15,
          9,
          15,
          5,
          14,
          4,
          5,
          4,
          3,
          2,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "6": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          8,
          10,
          11,
          13,
          11,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          12,
          3,
          11,
          3,
          10,
          5,
          8,
          6,
          8,
          7,
          7,
          8,
          7
        ],
        [
          11,
          0,
          11,
          4,
          10,
          4,
          9,
          3,
          8,
          3,
          7,
          2,
          4,
          2,
          3,
          1,
          3,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          12,
          3,
          11,
          3,
          10,
          5,
          8,
          6,
          8,
          7,
          7,
          11,
          7,
          12,
          6,
          13,
          6,
          13,
          4,
          10,
          4,
          9,
          3,
          8,
          3,
          7,
          2,
          4,
          2,
          3,
          1,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "7": {
    "pathData": {
      "rock": [
        [
          10,
          11,
          9,
          10,
          8,
          10,
          8,
          11,
          9,
          12
        ],
        [
          5,
          6,
          7,
          6,
          6,
          5,
          5,
          5
        ]
      ],
      "sand": [
        [
          11,
          4,
          10,
          5,
          8,
          5,
          7,
          6,
          4,
          6,
          4,
          3,
          3,
          2,
          3,
          0,
          11,
          0
        ],
        [
          9,
          10,
          11,
          12,
          11,
          16,
          3,
          16,
          3,
          13,
          4,
          12,
          4,
          10
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          4,
          16,
          4,
          10,
          3,
          10,
          3,
          6,
          4,
          6,
          4,
          0
        ]
      ],
      "dock": []
    }
  },
  "8": {
    "pathData": {
      "rock": [
        [
          10,
          14,
          8,
          12,
          7,
          12,
          7,
          13,
          9,
          15,
          10,
          15
        ],
        [
          6,
          4,
          7,
          5,
          8,
          4,
          8,
          3,
          7,
          3
        ]
      ],
      "sand": [
        [
          11,
          2,
          9,
          4,
          8,
          4,
          7,
          5,
          6,
          5,
          5,
          6,
          4,
          6,
          4,
          4,
          3,
          3,
          3,
          0,
          11,
          0
        ],
        [
          5,
          10,
          7,
          12,
          8,
          12,
          9,
          13,
          10,
          13,
          11,
          14,
          11,
          16,
          3,
          16,
          3,
          12,
          4,
          11,
          4,
          10
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          4,
          16,
          4,
          10,
          3,
          10,
          3,
          6,
          4,
          6,
          4,
          0
        ]
      ],
      "dock": []
    }
  },
  "9": {
    "pathData": {
      "rock": [
        [
          12,
          1,
          13,
          2,
          13,
          5,
          11,
          7,
          11,
          8,
          12,
          9,
          12,
          11,
          11,
          12,
          10,
          12,
          10,
          13,
          9,
          14,
          7,
          14,
          6,
          13,
          6,
          9,
          7,
          8,
          7,
          4,
          8,
          3,
          8,
          2,
          9,
          1
        ]
      ],
      "sand": [
        [
          11,
          1,
          12,
          1,
          13,
          2,
          13,
          5,
          11,
          7,
          11,
          8,
          12,
          9,
          12,
          11,
          11,
          12,
          10,
          12,
          11,
          13,
          11,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          12,
          3,
          11,
          3,
          6,
          4,
          5,
          4,
          2,
          3,
          1,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          12,
          3,
          11,
          3,
          6,
          4,
          5,
          4,
          2,
          3,
          1,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "10": {
    "pathData": {
      "rock": [
        [
          8,
          10,
          9,
          10,
          11,
          8,
          11,
          4,
          9,
          2,
          8,
          3,
          8,
          4,
          7,
          4,
          5,
          6,
          5,
          7
        ]
      ],
      "sand": [
        [
          11,
          1,
          10,
          2,
          10,
          3,
          11,
          4,
          11,
          8,
          9,
          10,
          9,
          12,
          11,
          14,
          11,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          10,
          3,
          9,
          3,
          6,
          4,
          5,
          4,
          2,
          3,
          1,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          10,
          3,
          9,
          3,
          6,
          4,
          5,
          4,
          2,
          3,
          1,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "11": {
    "pathData": {
      "rock": [
        [
          8,
          7,
          9,
          7,
          10,
          6,
          10,
          5,
          8,
          3,
          7,
          3,
          6,
          4,
          6,
          5
        ],
        [
          10,
          8,
          9,
          9,
          8,
          9,
          7,
          10,
          7,
          12,
          9,
          14,
          11,
          14,
          12,
          13,
          12,
          12,
          13,
          11,
          13,
          10,
          11,
          8
        ]
      ],
      "sand": [
        [
          11,
          2,
          9,
          4,
          10,
          5,
          10,
          6,
          9,
          7,
          9,
          8,
          11,
          8,
          13,
          10,
          13,
          11,
          12,
          12,
          12,
          13,
          11,
          14,
          11,
          16,
          3,
          16,
          3,
          14,
          5,
          12,
          5,
          9,
          4,
          8,
          4,
          3,
          3,
          2,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          14,
          5,
          12,
          5,
          9,
          4,
          8,
          4,
          3,
          3,
          2,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "12": {
    "pathData": {
      "rock": [
        [
          9,
          10,
          9,
          11,
          10,
          12,
          12,
          12,
          13,
          11,
          13,
          9,
          14,
          8,
          14,
          7,
          12,
          5,
          10,
          5,
          9,
          4,
          6,
          4,
          5,
          5,
          5,
          7,
          7,
          9,
          8,
          9
        ]
      ],
      "sand": [
        [
          11,
          2,
          10,
          3,
          10,
          4,
          11,
          5,
          12,
          5,
          14,
          7,
          14,
          8,
          13,
          9,
          13,
          11,
          12,
          12,
          11,
          12,
          10,
          13,
          10,
          14,
          11,
          15,
          11,
          16,
          3,
          16,
          3,
          14,
          5,
          12,
          5,
          10,
          3,
          8,
          3,
          6,
          4,
          5,
          4,
          2,
          3,
          1,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          14,
          5,
          12,
          5,
          10,
          3,
          8,
          3,
          6,
          4,
          5,
          4,
          2,
          3,
          1,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "13": {
    "pathData": {
      "rock": [
        [
          1,
          10,
          4,
          10,
          5,
          11,
          6,
          11,
          6,
          10,
          7,
          9,
          10,
          9,
          10,
          11,
          11,
          12,
          9,
          14,
          6,
          14,
          4,
          16,
          3,
          16,
          3,
          15,
          1,
          13,
          0,
          13,
          0,
          11
        ]
      ],
      "sand": [
        [
          1,
          10,
          4,
          10,
          5,
          11,
          6,
          11,
          6,
          10,
          7,
          9,
          10,
          9,
          10,
          11,
          11,
          12,
          11,
          16,
          3,
          16,
          3,
          15,
          1,
          13,
          0,
          13,
          0,
          11
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          15,
          1,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "14": {
    "pathData": {
      "rock": [
        [
          6,
          14,
          5,
          15,
          3,
          15,
          2,
          14,
          2,
          13,
          0,
          13,
          0,
          11,
          3,
          8,
          6,
          8,
          7,
          9,
          8,
          9,
          7,
          8,
          8,
          7,
          10,
          7,
          11,
          8,
          11,
          10,
          10,
          11,
          11,
          11,
          12,
          12,
          12,
          13,
          11,
          14
        ]
      ],
      "sand": [
        [
          3,
          8,
          6,
          8,
          7,
          9,
          8,
          9,
          7,
          8,
          8,
          7,
          10,
          7,
          11,
          8,
          11,
          10,
          10,
          11,
          11,
          11,
          12,
          12,
          12,
          13,
          11,
          14,
          11,
          16,
          3,
          16,
          3,
          15,
          2,
          14,
          2,
          13,
          0,
          13,
          0,
          11
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          15,
          2,
          14,
          2,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "15": {
    "pathData": {
      "rock": [
        [
          1,
          10,
          3,
          10,
          4,
          11,
          5,
          11,
          6,
          10,
          9,
          10,
          12,
          7,
          13,
          7,
          14,
          8,
          13,
          9,
          13,
          14,
          11,
          14,
          10,
          15,
          3,
          15,
          1,
          13,
          0,
          13,
          0,
          11
        ]
      ],
      "sand": [
        [
          1,
          10,
          3,
          10,
          4,
          11,
          5,
          11,
          6,
          10,
          9,
          10,
          12,
          7,
          13,
          7,
          14,
          8,
          13,
          9,
          13,
          14,
          11,
          14,
          11,
          16,
          3,
          16,
          3,
          15,
          1,
          13,
          0,
          13,
          0,
          11
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          15,
          1,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "16": {
    "pathData": {
      "rock": [
        [
          1,
          10,
          1,
          9,
          2,
          8,
          3,
          8,
          4,
          9,
          4,
          10,
          5,
          11,
          9,
          11,
          10,
          10,
          10,
          9,
          11,
          8,
          12,
          8,
          13,
          9,
          13,
          10,
          14,
          11,
          15,
          11,
          16,
          12,
          16,
          13,
          0,
          13,
          0,
          11
        ]
      ],
      "sand": [
        [
          1,
          10,
          1,
          9,
          2,
          8,
          3,
          8,
          4,
          7,
          10,
          7,
          11,
          8,
          12,
          8,
          13,
          9,
          13,
          10,
          14,
          11,
          15,
          11,
          15,
          12,
          14,
          13,
          12,
          13,
          11.5,
          12.5,
          11,
          13,
          0,
          13,
          0,
          11
        ],
        [
          15,
          12,
          16,
          12,
          16,
          13,
          15,
          13
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "17": {
    "pathData": {
      "rock": [
        [
          5,
          11,
          10,
          11,
          10,
          10,
          11,
          9,
          13,
          9,
          16,
          12,
          16,
          13,
          0,
          13,
          0,
          12,
          1,
          12,
          2,
          11,
          2,
          10,
          3,
          10,
          3,
          9,
          4,
          9,
          5,
          10
        ]
      ],
      "sand": [
        [
          1,
          12,
          3,
          10,
          3,
          8,
          4,
          7,
          10,
          7,
          11,
          8,
          11,
          9,
          13,
          9,
          16,
          12,
          16,
          13,
          9,
          13,
          8.5,
          12.5,
          8,
          13,
          0,
          13,
          0,
          12
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "18": {
    "pathData": {
      "rock": [
        [
          1,
          10,
          1,
          9,
          2,
          8,
          4,
          8,
          5,
          9,
          5,
          11,
          10,
          11,
          10,
          10,
          11,
          9,
          13,
          9,
          15,
          11,
          15,
          12,
          16,
          13,
          0,
          13,
          0,
          11
        ]
      ],
      "sand": [
        [
          1,
          10,
          1,
          9,
          2,
          8,
          3,
          8,
          4,
          7,
          10,
          7,
          11,
          8,
          11,
          9,
          13,
          9,
          15,
          11,
          15,
          12,
          16,
          13,
          0,
          13,
          0,
          11
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "19": {
    "pathData": {
      "rock": [
        [
          3,
          11,
          4,
          11,
          5,
          12,
          8,
          12,
          9,
          13,
          1,
          13
        ],
        [
          11,
          12,
          14,
          12,
          15,
          13,
          10,
          13
        ]
      ],
      "sand": [
        [
          3,
          11,
          3.5,
          11.5,
          4,
          11,
          5,
          12,
          8,
          12,
          9,
          13,
          1,
          13
        ],
        [
          11,
          12,
          14,
          12,
          15,
          13,
          10,
          13
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "20": {
    "pathData": {
      "rock": [
        [
          2,
          11,
          4,
          11,
          6,
          13,
          9,
          10,
          9,
          9,
          11,
          7,
          12,
          7,
          14,
          9,
          14,
          12,
          15,
          13,
          0,
          13
        ]
      ],
      "sand": [
        [
          2,
          11,
          4,
          11,
          6,
          13,
          9,
          10,
          9,
          9,
          11,
          7,
          12,
          7,
          14,
          9,
          14,
          12,
          15,
          13,
          0,
          13
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "21": {
    "pathData": {
      "rock": [
        [
          10,
          10,
          11,
          11,
          13,
          11,
          15,
          13,
          2,
          13,
          3,
          12,
          3,
          10,
          4,
          9,
          8,
          9,
          9,
          10
        ]
      ],
      "sand": [
        [
          3,
          12,
          3,
          10,
          4,
          9,
          8,
          9,
          9,
          10,
          10,
          10,
          11,
          11,
          13,
          11,
          15,
          13,
          2,
          13
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "22": {
    "pathData": {
      "rock": [
        [
          2,
          12,
          3,
          11,
          5,
          11,
          6,
          10,
          7,
          10,
          8,
          11,
          10,
          11,
          11,
          12,
          12,
          12,
          13,
          11,
          14,
          11,
          15,
          12,
          16,
          12,
          16,
          13,
          0,
          13,
          0,
          12
        ]
      ],
      "sand": [
        [
          2,
          12,
          3,
          11,
          5,
          11,
          6,
          10,
          7,
          10,
          8,
          11,
          10,
          11,
          11,
          12,
          12,
          12,
          13,
          11,
          14,
          11,
          15,
          12,
          16,
          12,
          16,
          13,
          0,
          13,
          0,
          12
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "23": {
    "pathData": {
      "rock": [
        [
          1,
          12,
          2,
          12,
          3,
          11,
          5,
          11,
          6,
          12,
          7,
          12,
          8,
          13,
          9,
          12,
          12,
          12,
          13,
          11,
          14,
          11,
          16,
          13,
          0,
          13
        ]
      ],
      "sand": [
        [
          1,
          12,
          2,
          12,
          3,
          11,
          5,
          11,
          6,
          12,
          7,
          12,
          8,
          13,
          9,
          12,
          12,
          12,
          13,
          11,
          14,
          11,
          16,
          13,
          0,
          13
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "24": {
    "pathData": {
      "rock": [
        [
          1,
          9,
          2,
          8,
          3,
          8,
          4,
          9,
          4,
          11,
          5,
          12,
          6,
          11,
          7,
          11,
          8,
          12,
          9,
          12,
          10,
          11,
          11,
          11,
          12,
          10,
          15,
          10,
          16,
          11,
          16,
          13,
          0,
          13,
          0,
          9
        ]
      ],
      "sand": [
        [
          1,
          9,
          2,
          8,
          3,
          8,
          4,
          9,
          4,
          11,
          5,
          12,
          6,
          11,
          7,
          11,
          8,
          12,
          9,
          12,
          10,
          11,
          11,
          11,
          12,
          10,
          15,
          10,
          16,
          11,
          16,
          13,
          0,
          13,
          0,
          9
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "25": {
    "pathData": {
      "rock": [
        [
          2,
          12,
          3,
          11,
          5,
          11,
          6,
          12,
          7,
          12,
          8,
          13,
          10,
          11,
          12,
          11,
          13,
          10,
          14,
          10,
          15,
          11,
          15,
          12,
          16,
          12,
          16,
          13,
          0,
          13,
          0,
          12
        ]
      ],
      "sand": [
        [
          2,
          12,
          3,
          11,
          3.5,
          11.5,
          4,
          11,
          5,
          11,
          6,
          12,
          7,
          12,
          8,
          13,
          10,
          11,
          12,
          11,
          13,
          10,
          14,
          10,
          15,
          11,
          15,
          12,
          16,
          12,
          16,
          13,
          0,
          13,
          0,
          12
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "26": {
    "pathData": {
      "rock": [
        [
          8,
          14,
          7,
          13,
          6,
          13,
          5,
          12,
          5,
          9,
          6,
          8,
          8,
          8,
          9,
          9,
          9,
          11,
          10,
          11,
          11,
          10,
          15,
          10,
          16,
          11,
          16,
          13,
          14,
          13,
          13,
          14,
          13,
          15,
          11,
          15,
          10,
          14
        ]
      ],
      "sand": [
        [
          5,
          9,
          6,
          8,
          8,
          8,
          9,
          9,
          9,
          11,
          10,
          11,
          11,
          10,
          15,
          10,
          16,
          11,
          16,
          13,
          14,
          13,
          13,
          14,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          16,
          0,
          16,
          13,
          14,
          13,
          13,
          14,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "27": {
    "pathData": {
      "rock": [
        [
          9,
          15,
          6,
          15,
          5,
          14,
          4,
          14,
          4,
          11,
          2,
          9,
          2,
          7,
          3,
          6,
          5,
          6,
          6,
          7,
          6,
          8,
          7,
          9,
          8,
          9,
          10,
          11,
          12,
          11,
          12,
          10,
          13,
          9,
          14,
          10,
          15,
          10,
          16,
          11,
          16,
          13,
          13,
          16,
          10,
          16
        ]
      ],
      "sand": [
        [
          5,
          14,
          4,
          14,
          4,
          11,
          2,
          9,
          2,
          7,
          3,
          6,
          5,
          6,
          6,
          7,
          6,
          8,
          7,
          9,
          8,
          9,
          10,
          11,
          12,
          11,
          12,
          10,
          13,
          9,
          14,
          10,
          15,
          10,
          16,
          11,
          16,
          13,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          16,
          0,
          16,
          13,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "28": {
    "pathData": {
      "rock": [
        [
          10,
          7,
          11,
          6,
          12,
          6,
          15,
          9,
          15,
          11,
          16,
          12,
          16,
          13,
          14,
          13,
          12,
          15,
          5,
          15,
          4,
          14,
          4,
          13,
          3,
          12,
          3,
          11,
          5,
          9,
          8,
          9,
          9,
          8,
          10,
          8
        ]
      ],
      "sand": [
        [
          5,
          15,
          4,
          14,
          4,
          13,
          3,
          12,
          3,
          11,
          5,
          9,
          8,
          9,
          9,
          8,
          10,
          8,
          10,
          7,
          11,
          6,
          12,
          6,
          15,
          9,
          15,
          11,
          16,
          12,
          16,
          13,
          14,
          13,
          14,
          14,
          13,
          15,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          16,
          0,
          16,
          13,
          14,
          13,
          14,
          14,
          13,
          15,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "29": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          14,
          13,
          13,
          14,
          10,
          14,
          9,
          13,
          6,
          13,
          5,
          12,
          1,
          12,
          0,
          13,
          0,
          3,
          2,
          3,
          3,
          4,
          7,
          4,
          8,
          3,
          10,
          3,
          11,
          4,
          13,
          4,
          14,
          3,
          16,
          3,
          16,
          13
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          2,
          3,
          3,
          4,
          7,
          4,
          8,
          3,
          10,
          3,
          11,
          4,
          13,
          4,
          14,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "30": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          15,
          13,
          14,
          14,
          12,
          14,
          11,
          13,
          8,
          13,
          6,
          15,
          4,
          15,
          3,
          14,
          2,
          14,
          1,
          13,
          0,
          13,
          0,
          3,
          2,
          3,
          3,
          4,
          4,
          4,
          5,
          5,
          10,
          5,
          11,
          4,
          14,
          4,
          15,
          3,
          16,
          3,
          16,
          13
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          2,
          3,
          3,
          4,
          4,
          4,
          5,
          5,
          10,
          5,
          11,
          4,
          14,
          4,
          15,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "31": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          15,
          13,
          14,
          14,
          12,
          14,
          11,
          15,
          7,
          15,
          6,
          14,
          4,
          14,
          3,
          13,
          0,
          13,
          0,
          3,
          1,
          3,
          4,
          6,
          8,
          6,
          10,
          4,
          13,
          4,
          14,
          3,
          16,
          3,
          16,
          13
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          1,
          3,
          4,
          6,
          8,
          6,
          10,
          4,
          13,
          4,
          14,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "32": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          15,
          13,
          14,
          12,
          13,
          12,
          11,
          14,
          8,
          14,
          7,
          15,
          4,
          15,
          3,
          14,
          2,
          14,
          1,
          13,
          0,
          13,
          0,
          3,
          1,
          3,
          3,
          5,
          4,
          5,
          5,
          6,
          8,
          6,
          9,
          5,
          12,
          5,
          13,
          4,
          14,
          4,
          15,
          3,
          16,
          3,
          16,
          13
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          1,
          3,
          3,
          5,
          4,
          5,
          5,
          6,
          8,
          6,
          9,
          5,
          12,
          5,
          13,
          4,
          14,
          4,
          15,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "34": {
    "pathData": {
      "rock": [
        [
          15,
          5,
          14,
          5,
          13,
          4,
          14,
          3,
          16,
          3,
          16,
          4
        ],
        [
          11,
          12,
          10,
          11,
          10,
          6,
          9,
          5,
          9,
          3,
          11,
          3,
          11,
          6,
          16,
          6,
          16,
          12
        ]
      ],
      "sand": [
        [
          11,
          12,
          10,
          11,
          10,
          6,
          9,
          6,
          7,
          8,
          6,
          8,
          1,
          13,
          0,
          13,
          0,
          3,
          16,
          3,
          16,
          12
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "35": {
    "pathData": {
      "rock": [
        [
          5,
          5,
          4,
          6,
          5,
          7,
          5,
          11,
          4,
          12,
          0,
          12,
          0,
          3,
          5,
          3
        ]
      ],
      "sand": [
        [
          15,
          13,
          10,
          8,
          6,
          8,
          5,
          7,
          5,
          11,
          4,
          12,
          0,
          12,
          0,
          3,
          16,
          3,
          16,
          13
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "39": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          2,
          12,
          3,
          12,
          6,
          11,
          7,
          11,
          10,
          8,
          13,
          6,
          13,
          5,
          12,
          3,
          12,
          2,
          13,
          0,
          13,
          0,
          3,
          2,
          3,
          3,
          2,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          2,
          3,
          3,
          2,
          3,
          0,
          16,
          0,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "40": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          5,
          9,
          7,
          7,
          7,
          5,
          9,
          5,
          11,
          3,
          13,
          0,
          13,
          0,
          3,
          1,
          3,
          3,
          1,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          1,
          3,
          3,
          1,
          3,
          0,
          16,
          0,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "41": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          2,
          13,
          4,
          13,
          6,
          12,
          7,
          12,
          10,
          9,
          13,
          7,
          13,
          6,
          14,
          2,
          14,
          1,
          13,
          0,
          13,
          0,
          3,
          2,
          3,
          3,
          2,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          2,
          3,
          3,
          2,
          3,
          0,
          16,
          0,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "42": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          5,
          9,
          7,
          7,
          7,
          4,
          10,
          4,
          11,
          2,
          13,
          0,
          13,
          0,
          3,
          1,
          3,
          3,
          1,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          1,
          3,
          3,
          1,
          3,
          0,
          16,
          0,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "43": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          7,
          9,
          9,
          8,
          9,
          7,
          10,
          5,
          10,
          2,
          13,
          0,
          13,
          0,
          3,
          1,
          3,
          3,
          1,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          1,
          3,
          3,
          1,
          3,
          0,
          16,
          0,
          16,
          16
        ]
      ],
      "dock": [
        [
          15,
          4,
          15,
          6,
          8,
          6,
          8,
          4
        ]
      ]
    }
  },
  "44": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          1,
          8,
          4,
          8,
          7,
          9,
          8,
          9,
          12,
          7,
          14,
          3,
          14,
          2,
          13,
          0,
          13,
          0,
          3,
          1,
          3,
          2,
          2,
          3,
          2,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          1,
          3,
          2,
          2,
          3,
          2,
          3,
          0,
          16,
          0,
          16,
          16
        ]
      ],
      "dock": [
        [
          8,
          11,
          8,
          9,
          15,
          9,
          15,
          11
        ]
      ]
    }
  },
  "45": {
    "pathData": {
      "rock": [
        [
          6,
          10,
          6,
          9,
          5,
          10,
          5,
          11
        ],
        [
          10,
          10,
          11,
          11,
          11,
          9,
          10,
          9
        ]
      ],
      "sand": [
        [
          12,
          13,
          11,
          12,
          11,
          11,
          10,
          10,
          10,
          4,
          11,
          4,
          12,
          3,
          16,
          3,
          16,
          13
        ],
        [
          6,
          10,
          5,
          11,
          5,
          12,
          4,
          13,
          0,
          13,
          0,
          3,
          4,
          3,
          5,
          4,
          6,
          4
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          4,
          6,
          4,
          6,
          3,
          10,
          3,
          10,
          4,
          16,
          4,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "46": {
    "pathData": {
      "rock": [
        [
          12,
          11,
          12,
          10,
          11,
          9,
          11,
          11
        ],
        [
          4,
          7,
          3,
          8,
          4,
          8
        ],
        [
          4,
          11,
          4,
          10,
          3,
          10,
          2,
          11,
          3,
          12
        ]
      ],
      "sand": [
        [
          12,
          13,
          11,
          12,
          11,
          9,
          10,
          8,
          10,
          4,
          12,
          4,
          13,
          3,
          16,
          3,
          16,
          13
        ],
        [
          6,
          6,
          5,
          6,
          4,
          7,
          4,
          11,
          2,
          13,
          0,
          13,
          0,
          3,
          2,
          3,
          3,
          4,
          6,
          4
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          4,
          6,
          4,
          6,
          3,
          10,
          3,
          10,
          4,
          16,
          4,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "47": {
    "pathData": {
      "rock": [
        [
          12,
          11,
          13,
          10,
          12,
          9,
          11,
          9,
          11,
          10
        ],
        [
          4,
          10,
          3,
          11,
          3,
          12,
          4,
          12,
          5,
          11,
          5,
          10
        ]
      ],
      "sand": [
        [
          14,
          13,
          11,
          10,
          11,
          7,
          10,
          6,
          10,
          4,
          12,
          4,
          13,
          3,
          16,
          3,
          16,
          13
        ],
        [
          6,
          8,
          5,
          9,
          5,
          12,
          4,
          13,
          0,
          13,
          0,
          3,
          2,
          3,
          3,
          4,
          6,
          4
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          4,
          6,
          4,
          6,
          3,
          10,
          3,
          10,
          4,
          16,
          4,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "48": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          15,
          13,
          14,
          14,
          11,
          14,
          10,
          13,
          7,
          13,
          5,
          11,
          5,
          8,
          6,
          7,
          6,
          2,
          5,
          1,
          5,
          0,
          13,
          0,
          13,
          2,
          14,
          3,
          16,
          3,
          16,
          13
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          2,
          14,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "49": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          15,
          13,
          14,
          12,
          13,
          12,
          9,
          8,
          9,
          6,
          7,
          4,
          7,
          3,
          5,
          1,
          5,
          0,
          13,
          0,
          13,
          1,
          15,
          3,
          16,
          3,
          16,
          13
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          1,
          15,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "50": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          14,
          13,
          12,
          15,
          11,
          15,
          10,
          14,
          8,
          14,
          7,
          13,
          7,
          12,
          6,
          11,
          6,
          9,
          5,
          8,
          5,
          7,
          4,
          6,
          4,
          3,
          5,
          2,
          5,
          0,
          13,
          0,
          13,
          2,
          15,
          2,
          16,
          3,
          16,
          13
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          2,
          15,
          2,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "51": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          13,
          13,
          11,
          11,
          11,
          8,
          7,
          4,
          6,
          4,
          5,
          3,
          5,
          0,
          13,
          0,
          13,
          1,
          14,
          2,
          14,
          3,
          16,
          3,
          16,
          13
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          1,
          14,
          2,
          14,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "52": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          14,
          13,
          13,
          14,
          9,
          14,
          6,
          11,
          6,
          9,
          4,
          7,
          4,
          4,
          5,
          3,
          5,
          0,
          13,
          0,
          13,
          2,
          15,
          2,
          16,
          3,
          16,
          13
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          2,
          15,
          2,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": [
        [
          7,
          4,
          7,
          6,
          1,
          6,
          1,
          4
        ]
      ]
    }
  },
  "53": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          14,
          13,
          12,
          15,
          10,
          15,
          7,
          12,
          7,
          10,
          8,
          9,
          8,
          5,
          7,
          4,
          7,
          3,
          5,
          1,
          5,
          0,
          13,
          0,
          13,
          1,
          15,
          3,
          16,
          3,
          16,
          13
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          1,
          15,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": [
        [
          10,
          12,
          2,
          12,
          2,
          10,
          10,
          10
        ]
      ]
    }
  },
  "54": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          4,
          15,
          4,
          11,
          5,
          10,
          5,
          8,
          6,
          7,
          6,
          2,
          5,
          1,
          5,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          4,
          13,
          5,
          13,
          8,
          12,
          9,
          12,
          13,
          13,
          14,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          4,
          13,
          5,
          13,
          8,
          12,
          9,
          12,
          13,
          13,
          14,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "55": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          5,
          14,
          6,
          13,
          6,
          11,
          5,
          10,
          5,
          7,
          6,
          6,
          6,
          2,
          5,
          1,
          5,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          4,
          11,
          5,
          11,
          10,
          12,
          11,
          12,
          13,
          13,
          14,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          4,
          11,
          5,
          11,
          10,
          12,
          11,
          12,
          13,
          13,
          14,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "56": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          5,
          16,
          5,
          14,
          4,
          13,
          3,
          13,
          1,
          11,
          1,
          9,
          4,
          6,
          4,
          1,
          5,
          0,
          13,
          0,
          13,
          2,
          12,
          3,
          12,
          4,
          11,
          5,
          11,
          8,
          10,
          9,
          10,
          11,
          12,
          13,
          12,
          14,
          13,
          15,
          13,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          2,
          12,
          3,
          12,
          4,
          11,
          5,
          11,
          8,
          10,
          9,
          10,
          11,
          12,
          13,
          12,
          14,
          13,
          15,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "57": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          5,
          15,
          6,
          14,
          6,
          12,
          7,
          11,
          7,
          8,
          6,
          7,
          6,
          5,
          5,
          4,
          5,
          0,
          13,
          0,
          13,
          1,
          11,
          3,
          11,
          6,
          12,
          7,
          12,
          8,
          13,
          9,
          13,
          11,
          12,
          12,
          12,
          14,
          13,
          15,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          1,
          11,
          3,
          11,
          6,
          12,
          7,
          12,
          8,
          13,
          9,
          13,
          11,
          12,
          12,
          12,
          14,
          13,
          15,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "58": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          5,
          15,
          6,
          14,
          6,
          12,
          5,
          11,
          5,
          8,
          6,
          7,
          6,
          5,
          5,
          4,
          5,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          6,
          13,
          7,
          13,
          9,
          12,
          10,
          12,
          13,
          13,
          14,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          6,
          13,
          7,
          13,
          9,
          12,
          10,
          12,
          13,
          13,
          14,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "59": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          5,
          15,
          4,
          14,
          4,
          13,
          3,
          12,
          3,
          10,
          11,
          10,
          13,
          12,
          13,
          16,
          5,
          16
        ],
        [
          5,
          2,
          5,
          0,
          13,
          0,
          13,
          2,
          10,
          5,
          6,
          5,
          5,
          4,
          3,
          4
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          7,
          1,
          8,
          1,
          9,
          2,
          10,
          11,
          10,
          13,
          12,
          13,
          16
        ],
        [
          0,
          0,
          13,
          0,
          13,
          2,
          10,
          5,
          6,
          5,
          5,
          4,
          1,
          4,
          0,
          5
        ]
      ],
      "dock": []
    }
  },
  "60": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          5,
          15,
          6,
          14,
          6,
          11,
          5,
          10,
          7,
          8,
          9,
          8,
          11,
          10,
          11,
          11,
          12,
          12,
          12,
          13,
          13,
          14,
          13,
          16,
          5,
          16
        ],
        [
          5,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          4,
          9,
          4,
          7,
          2,
          5,
          2
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          8,
          2,
          10,
          5,
          10,
          7,
          8,
          9,
          8,
          11,
          10,
          11,
          11,
          12,
          12,
          12,
          13,
          13,
          14,
          13,
          16
        ],
        [
          0,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          4,
          9,
          4,
          7,
          2,
          3,
          2,
          2,
          3,
          1,
          3,
          0,
          4
        ]
      ],
      "dock": []
    }
  },
  "61": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          5,
          15,
          6,
          14,
          6,
          13,
          7,
          12,
          7,
          8,
          9,
          8,
          11,
          10,
          11,
          11,
          12,
          12,
          12,
          14,
          13,
          15,
          13,
          16,
          5,
          16
        ],
        [
          5,
          3,
          5,
          0,
          13,
          0,
          11,
          2,
          9,
          2,
          8,
          3,
          7,
          3,
          6,
          4
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          11,
          2,
          9,
          2,
          8,
          3,
          7,
          3,
          6,
          4,
          3,
          4,
          2,
          5,
          2,
          6,
          3,
          7,
          4,
          7,
          5,
          8,
          9,
          8,
          11,
          10,
          11,
          11,
          12,
          12,
          12,
          14,
          13,
          15,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "62": {
    "pathData": {
      "rock": [
        [
          9,
          5,
          7,
          5,
          8,
          6,
          9,
          6
        ],
        [
          8,
          12,
          9,
          12,
          10,
          11,
          9,
          10,
          8,
          10,
          7,
          11
        ]
      ],
      "sand": [
        [
          5,
          12,
          6,
          11,
          7,
          11,
          8,
          10,
          12,
          10,
          12,
          11,
          13,
          12,
          13,
          16,
          5,
          16
        ],
        [
          8,
          6,
          7,
          5,
          6,
          5,
          5,
          4,
          5,
          0,
          13,
          0,
          13,
          3,
          12,
          4,
          12,
          6
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          12,
          0,
          12,
          6,
          13,
          6,
          13,
          10,
          12,
          10,
          12,
          16
        ]
      ],
      "dock": []
    }
  },
  "63": {
    "pathData": {
      "rock": [
        [
          6,
          13,
          6,
          14,
          7,
          14,
          8,
          13,
          8,
          12,
          7,
          12
        ],
        [
          8,
          5,
          10,
          5,
          10,
          4,
          9,
          3,
          7,
          3,
          7,
          4
        ]
      ],
      "sand": [
        [
          5,
          14,
          7,
          12,
          8,
          12,
          10,
          10,
          12,
          10,
          12,
          13,
          13,
          14,
          13,
          16,
          5,
          16
        ],
        [
          10,
          6,
          9,
          5,
          8,
          5,
          7,
          4,
          7,
          3,
          6,
          3,
          5,
          2,
          5,
          0,
          13,
          0,
          13,
          4,
          12,
          5,
          12,
          6
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          12,
          0,
          12,
          6,
          13,
          6,
          13,
          10,
          12,
          10,
          12,
          16
        ]
      ],
      "dock": []
    }
  },
  "64": {
    "pathData": {
      "rock": [
        [
          9,
          13,
          8,
          14,
          5,
          14,
          3,
          12,
          2,
          12,
          1,
          11,
          1,
          5,
          2,
          4,
          2,
          3,
          3,
          2,
          8,
          2,
          9,
          3
        ]
      ],
      "sand": [
        [
          5,
          14,
          3,
          12,
          2,
          12,
          1,
          11,
          1,
          5,
          2,
          4,
          2,
          3,
          3,
          2,
          5,
          2,
          5,
          0,
          13,
          0,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "65": {
    "pathData": {
      "rock": [
        [
          8,
          3,
          8,
          1,
          7,
          0,
          6,
          0,
          3,
          3,
          3,
          5,
          5,
          7,
          7,
          7,
          9,
          5,
          9,
          4
        ],
        [
          10,
          10,
          9,
          9,
          7,
          9,
          5,
          11,
          7,
          13,
          9,
          13,
          10,
          12
        ]
      ],
      "sand": [
        [
          5,
          13,
          6,
          12,
          5,
          11,
          7,
          9,
          7,
          8,
          6,
          7,
          5,
          7,
          3,
          5,
          3,
          3,
          4,
          2,
          4,
          1,
          5,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          7,
          13,
          8,
          13,
          10,
          12,
          11,
          12,
          14,
          13,
          15,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          7,
          13,
          8,
          13,
          10,
          12,
          11,
          12,
          14,
          13,
          15,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "66": {
    "pathData": {
      "rock": [
        [
          7,
          2,
          4,
          2,
          3,
          3,
          3,
          4,
          4,
          5,
          4,
          7,
          2,
          7,
          1,
          8,
          1,
          10,
          2,
          11,
          3,
          11,
          3,
          12,
          4,
          13,
          6,
          13,
          8,
          11,
          8,
          7,
          9,
          6,
          9,
          4
        ]
      ],
      "sand": [
        [
          5,
          14,
          3,
          12,
          3,
          11,
          2,
          11,
          1,
          10,
          1,
          8,
          2,
          7,
          4,
          7,
          4,
          5,
          3,
          4,
          3,
          3,
          4,
          2,
          5,
          2,
          5,
          0,
          13,
          0,
          13,
          2,
          12,
          3,
          12,
          6,
          10,
          8,
          10,
          11,
          11,
          12,
          11,
          13,
          13,
          15,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          2,
          12,
          3,
          12,
          6,
          10,
          8,
          10,
          11,
          11,
          12,
          11,
          13,
          13,
          15,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "67": {
    "pathData": {
      "rock": [
        [
          10,
          8,
          10,
          6,
          8,
          4,
          7,
          4,
          6,
          3,
          5,
          3,
          4,
          4,
          5,
          5,
          5,
          7,
          6,
          8,
          6,
          9,
          7,
          10,
          8,
          10
        ]
      ],
      "sand": [
        [
          5,
          14,
          6,
          13,
          6,
          10,
          7,
          10,
          6,
          9,
          6,
          8,
          5,
          7,
          5,
          5,
          4,
          4,
          5,
          3,
          6,
          3,
          6,
          1,
          5,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          7,
          13,
          8,
          13,
          10,
          12,
          11,
          12,
          14,
          13,
          15,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          7,
          13,
          8,
          13,
          10,
          12,
          11,
          12,
          14,
          13,
          15,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "68": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          10,
          1,
          10,
          4,
          11,
          5,
          11,
          6,
          12,
          7,
          12,
          9,
          10,
          11,
          10,
          14,
          11,
          15,
          11,
          16,
          3,
          16,
          3,
          14,
          4,
          13,
          4,
          11,
          5,
          10,
          5,
          9,
          6,
          8,
          6,
          5,
          5,
          4,
          5,
          3,
          3,
          1,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          14,
          4,
          13,
          4,
          11,
          5,
          10,
          5,
          9,
          6,
          8,
          6,
          5,
          5,
          4,
          5,
          3,
          3,
          1,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "69": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          1,
          12,
          2,
          12,
          5,
          11,
          6,
          11,
          8,
          10,
          9,
          10,
          13,
          11,
          14,
          11,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          11,
          3,
          10,
          3,
          8,
          4,
          7,
          4,
          3,
          3,
          2,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          11,
          3,
          10,
          3,
          8,
          4,
          7,
          4,
          3,
          3,
          2,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "70": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          15,
          13,
          14,
          12,
          12,
          12,
          10,
          14,
          8,
          14,
          7,
          15,
          4,
          15,
          3,
          14,
          2,
          14,
          1,
          13,
          0,
          13,
          0,
          3,
          2,
          3,
          3,
          4,
          5,
          4,
          6,
          5,
          7,
          5,
          8,
          6,
          11,
          6,
          13,
          4,
          14,
          4,
          15,
          3,
          16,
          3,
          16,
          13
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          2,
          3,
          3,
          4,
          5,
          4,
          6,
          5,
          7,
          5,
          8,
          6,
          11,
          6,
          13,
          4,
          14,
          4,
          15,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "71": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          15,
          14,
          13,
          14,
          12,
          15,
          7,
          15,
          6,
          16,
          4,
          16,
          1,
          13,
          0,
          13,
          0,
          3,
          1,
          3,
          4,
          6,
          8,
          6,
          10,
          4,
          13,
          4,
          14,
          3,
          16,
          3,
          16,
          13
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          1,
          3,
          4,
          6,
          8,
          6,
          10,
          4,
          13,
          4,
          14,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "72": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          5,
          15,
          6,
          14,
          6,
          13,
          8,
          11,
          8,
          6,
          5,
          3,
          5,
          0,
          13,
          0,
          13,
          4,
          12,
          5,
          12,
          6,
          11,
          7,
          11,
          12,
          13,
          14,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          4,
          12,
          5,
          12,
          6,
          11,
          7,
          11,
          12,
          13,
          14,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "73": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          5,
          14,
          6,
          13,
          6,
          10,
          8,
          8,
          8,
          4,
          5,
          1,
          5,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          4,
          11,
          5,
          11,
          12,
          13,
          14,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          4,
          11,
          5,
          11,
          12,
          13,
          14,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "74": {
    "pathData": {
      "rock": [
        [
          5,
          6,
          5,
          9,
          7,
          9,
          8,
          8,
          8,
          6,
          7,
          5,
          6,
          5
        ]
      ],
      "sand": [
        [
          5,
          14,
          6,
          13,
          6,
          10,
          7,
          9,
          5,
          9,
          5,
          6,
          6,
          5,
          7,
          5,
          8,
          6,
          8,
          5,
          5,
          2,
          5,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          3,
          11,
          4,
          11,
          9,
          12,
          10,
          12,
          13,
          13,
          14,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          3,
          11,
          4,
          11,
          9,
          12,
          10,
          12,
          13,
          13,
          14,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "75": {
    "pathData": {
      "rock": [
        [
          11,
          7,
          11,
          5,
          12,
          4,
          13,
          5,
          13,
          7,
          12,
          8
        ]
      ],
      "sand": [
        [
          5,
          15,
          7,
          13,
          7,
          12,
          9,
          10,
          9,
          8,
          8,
          7,
          8,
          5,
          5,
          2,
          5,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          4,
          13,
          5,
          13,
          7,
          12,
          8,
          12,
          13,
          13,
          14,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          4,
          13,
          5,
          13,
          7,
          12,
          8,
          12,
          13,
          13,
          14,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "76": {
    "pathData": {
      "rock": [
        [
          10,
          9,
          11,
          9,
          12,
          10,
          12,
          12,
          13,
          13,
          12,
          14,
          11,
          14,
          9,
          12,
          9,
          10
        ]
      ],
      "sand": [
        [
          5,
          14,
          7,
          12,
          7,
          9,
          8,
          8,
          8,
          5,
          5,
          2,
          5,
          0,
          13,
          0,
          13,
          3,
          12,
          4,
          12,
          12,
          13,
          13,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          3,
          12,
          4,
          12,
          12,
          13,
          13,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "77": {
    "pathData": {
      "rock": [
        [
          9,
          7,
          9,
          5,
          11,
          3,
          12,
          4,
          12,
          8,
          10,
          8
        ]
      ],
      "sand": [
        [
          5,
          14,
          6,
          13,
          6,
          10,
          7,
          9,
          7,
          4,
          5,
          2,
          5,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          6,
          13,
          7,
          13,
          16,
          5,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          1,
          12,
          2,
          12,
          6,
          13,
          7,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "78": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          1,
          8,
          4,
          8,
          7,
          9,
          8,
          9,
          10,
          10,
          11,
          10,
          12,
          11,
          13,
          11,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          10,
          5,
          9,
          5,
          4,
          4,
          3,
          4,
          2,
          3,
          1,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          10,
          5,
          9,
          5,
          4,
          4,
          3,
          4,
          2,
          3,
          1,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "79": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          2,
          10,
          3,
          10,
          4,
          8,
          6,
          8,
          11,
          10,
          13,
          10,
          14,
          11,
          15,
          11,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          13,
          5,
          12,
          5,
          9,
          4,
          8,
          4,
          6,
          3,
          5,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          13,
          5,
          12,
          5,
          9,
          4,
          8,
          4,
          6,
          3,
          5,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "80": {
    "pathData": {
      "rock": [
        [
          5,
          3,
          6,
          3,
          7,
          4,
          7,
          5,
          5,
          7,
          4,
          6,
          4,
          4
        ]
      ],
      "sand": [
        [
          11,
          2,
          9,
          4,
          9,
          9,
          10,
          10,
          10,
          13,
          11,
          14,
          11,
          16,
          3,
          16,
          3,
          7,
          4,
          6,
          4,
          2,
          3,
          1,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          7,
          4,
          6,
          4,
          2,
          3,
          1,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "81": {
    "pathData": {
      "rock": [
        [
          6,
          14,
          4,
          12,
          4,
          10,
          5,
          9,
          6,
          9,
          7,
          10,
          7,
          13
        ]
      ],
      "sand": [
        [
          11,
          2,
          8,
          5,
          8,
          8,
          9,
          9,
          9,
          13,
          11,
          15,
          11,
          16,
          3,
          16,
          3,
          14,
          4,
          13,
          4,
          5,
          3,
          4,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          14,
          4,
          13,
          4,
          5,
          3,
          4,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "82": {
    "pathData": {
      "rock": [
        [
          9,
          12,
          10,
          13,
          11,
          13,
          12,
          12,
          10,
          10,
          9,
          10
        ]
      ],
      "sand": [
        [
          11,
          4,
          10,
          5,
          10,
          6,
          8,
          8,
          8,
          11,
          9,
          12,
          9,
          10,
          10,
          10,
          12,
          12,
          11,
          13,
          10,
          13,
          10,
          14,
          11,
          15,
          11,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          13,
          5,
          12,
          5,
          5,
          4,
          4,
          4,
          3,
          3,
          2,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          15,
          4,
          14,
          4,
          13,
          5,
          12,
          5,
          5,
          4,
          4,
          4,
          3,
          3,
          2,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "83": {
    "pathData": {
      "rock": [
        [
          6,
          3,
          7,
          4,
          5,
          6,
          4,
          6,
          4,
          3
        ]
      ],
      "sand": [
        [
          11,
          2,
          9,
          4,
          9,
          7,
          8,
          8,
          8,
          11,
          9,
          12,
          9,
          13,
          11,
          15,
          11,
          16,
          3,
          16,
          3,
          12,
          4,
          11,
          4,
          2,
          3,
          1,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          12,
          4,
          11,
          4,
          2,
          3,
          1,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "900": {
    "pathData": {
      "rock": [
        [
          8,
          14,
          7,
          13,
          3,
          13,
          2,
          12,
          2,
          9,
          3,
          8,
          8,
          8,
          9,
          9,
          9,
          11,
          10,
          11,
          11,
          10,
          15,
          10,
          16,
          11,
          16,
          13,
          13,
          16,
          12,
          16,
          10,
          14
        ]
      ],
      "sand": [
        [
          8,
          8,
          9,
          9,
          9,
          11,
          10,
          11,
          11,
          10,
          15,
          10,
          16,
          11,
          16,
          13,
          13,
          16,
          5,
          16,
          5,
          13,
          3,
          13,
          2,
          12,
          2,
          9,
          3,
          8
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          16,
          0,
          16,
          13,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "901": {
    "pathData": {
      "rock": [
        [
          10,
          14,
          6,
          14,
          4,
          16,
          3,
          16,
          0,
          13,
          0,
          11,
          1,
          10,
          7,
          10,
          8,
          9,
          12,
          9,
          13,
          10,
          13,
          12,
          12,
          13,
          11,
          13
        ]
      ],
      "sand": [
        [
          1,
          10,
          7,
          10,
          8,
          9,
          12,
          9,
          13,
          10,
          13,
          12,
          12,
          13,
          11,
          13,
          11,
          16,
          3,
          16,
          0,
          13,
          0,
          11
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          16,
          3,
          16,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "902": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          13,
          5,
          7,
          5,
          0,
          13,
          0,
          13,
          1,
          15,
          3,
          16,
          3,
          16,
          13
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          1,
          15,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "903": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          8,
          6,
          13,
          0,
          13,
          0,
          3,
          1,
          3,
          3,
          1,
          3,
          0,
          11,
          0
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          1,
          3,
          3,
          1,
          3,
          0,
          16,
          0,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "904": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          5,
          16,
          5,
          0,
          13,
          0,
          13,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "905": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          0,
          11,
          16,
          3,
          16,
          3,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "906": {
    "pathData": {
      "rock": [
        [
          2,
          12,
          7,
          12,
          8,
          13,
          1,
          13
        ],
        [
          10,
          12,
          14,
          12,
          15,
          13,
          9,
          13
        ]
      ],
      "sand": [
        [
          2,
          12,
          7,
          12,
          8,
          13,
          1,
          13
        ],
        [
          10,
          12,
          14,
          12,
          15,
          13,
          9,
          13
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "907": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          16,
          13,
          0,
          13,
          0,
          3,
          16,
          3
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "908": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          12,
          13,
          10,
          11,
          10,
          3,
          16,
          3,
          16,
          13
        ],
        [
          6,
          11,
          4,
          13,
          0,
          13,
          0,
          3,
          6,
          3
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          3,
          6,
          3,
          10,
          3,
          16,
          3,
          16,
          16
        ]
      ],
      "dock": []
    }
  },
  "909": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          5,
          12,
          7,
          10,
          13,
          10,
          13,
          16,
          5,
          16
        ],
        [
          7,
          6,
          5,
          4,
          5,
          0,
          13,
          0,
          13,
          6
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          6,
          13,
          10,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "910": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          4,
          9,
          6,
          3,
          6,
          3,
          0,
          11,
          0
        ],
        [
          9,
          10,
          11,
          12,
          11,
          16,
          3,
          16,
          3,
          10
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          10,
          3,
          6,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "911": {
    "pathData": {
      "rock": [
        [
          4,
          10,
          4,
          11,
          5,
          12,
          11,
          12,
          12,
          11,
          12,
          10,
          15,
          13,
          1,
          13
        ]
      ],
      "sand": [
        [
          4,
          10,
          4,
          9,
          5,
          8,
          11,
          8,
          12,
          9,
          12,
          10,
          15,
          13,
          9,
          13,
          8.5,
          12.5,
          8,
          13,
          1,
          13
        ]
      ],
      "water": [
        [
          0,
          0,
          16,
          0,
          16,
          13,
          0,
          13
        ]
      ],
      "dock": []
    }
  },
  "912": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          5,
          0,
          13,
          0,
          13,
          5,
          12,
          6,
          5,
          6
        ],
        [
          5,
          16,
          5,
          10,
          12,
          10,
          13,
          11,
          13,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          5,
          12,
          6,
          4,
          6,
          3,
          7,
          3,
          9,
          4,
          10,
          12,
          10,
          13,
          11,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "913": {
    "pathData": {
      "rock": [],
      "sand": [
        [
          11,
          16,
          3,
          16,
          3,
          11,
          4,
          10,
          11,
          10
        ],
        [
          11,
          0,
          11,
          6,
          4,
          6,
          3,
          5,
          3,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          11,
          4,
          10,
          12,
          10,
          13,
          9,
          13,
          7,
          12,
          6,
          4,
          6,
          3,
          5,
          3,
          0
        ]
      ],
      "dock": []
    }
  },
  "914": {
    "pathData": {
      "rock": [
        [
          4,
          8,
          4,
          5,
          5,
          4,
          8,
          4,
          9,
          5,
          9,
          9,
          8,
          10,
          6,
          10
        ]
      ],
      "sand": [
        [
          5,
          16,
          5,
          0,
          13,
          0,
          13,
          16
        ]
      ],
      "water": [
        [
          0,
          16,
          0,
          0,
          13,
          0,
          13,
          16
        ]
      ],
      "dock": []
    }
  },
  "915": {
    "pathData": {
      "rock": [
        [
          12,
          8,
          12,
          5,
          11,
          4,
          8,
          4,
          7,
          5,
          7,
          9,
          8,
          10,
          10,
          10
        ]
      ],
      "sand": [
        [
          11,
          0,
          11,
          16,
          3,
          16,
          3,
          0
        ]
      ],
      "water": [
        [
          16,
          0,
          16,
          16,
          3,
          16,
          3,
          0
        ]
      ],
      "dock": []
    }
  }
};

export const airportOverlaySvg: string | null = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 224.28 224.28\"><defs><style>.cls-1{fill:#534d41;}.cls-2{fill:#edebd4;}</style></defs><title>amenity-airport</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><circle class=\"cls-1\" cx=\"112.14\" cy=\"112.14\" r=\"112.14\"/><g id=\"_9VChQJ\" data-name=\"9VChQJ\"><path class=\"cls-2\" d=\"M78.73,190.54c.71-.61,13.74-9.48,19.72-13.06,3.87-2.31,4-5.44,4.08-10,.16-8.35-.63-16.57-1-24.85-.33-8.45-2.81-10.85-11.34-9.69-12.62,1.7-40,10.13-41.58,10.5-4,1-8.65,2.45-11.17-2.17-2.83-5.2,1.18-8.7,4.92-11,14.1-8.68,28.45-17,42.87-25.08,8.44-4.74,13-9.66,11-20.36-1.6-8.63-3.36-17.58-2.29-26.6,1.26-10.5,3.53-20.7,10.22-29.25,5.69-7.28,10.6-7.39,16.08.15,9.27,12.75,11.34,27.39,9.65,42.68-.45,4.1-.9,8.33-1.7,12.25-2.44,12,.46,16.08,9.08,21,13,7.39,44.22,24.6,45.71,25.84,3.06,2.54,6,5.32,4.25,9.72-1.85,4.72-6.25,4.36-9.83,3.27-11-3.33-36.15-10-37.7-10.41-12.09-3-15.53-.17-16.72,10.49-1.27,11.27-1.14,13.26-1.27,22.9-.12,9.13,3.65,11.75,14.76,17.89,3.87,2.13,14.38,7.63,11.51,12.7-2.69,4.77-9.16,3-14.25,1.4-14.57-4.54-29.16-5-43.7.2-2.1.75-11,4.08-13.88-1.11C74.33,194.65,76.58,192.55,78.73,190.54Z\"/></g></g></g></svg>";
